import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=b6a22586&scoped=true"
import script from "./Todos.vue?vue&type=script&lang=ts"
export * from "./Todos.vue?vue&type=script&lang=ts"
import style0 from "./Todos.vue?vue&type=style&index=0&id=b6a22586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a22586",
  null
  
)

export default component.exports